(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-customer-trust"]) return;
  try {
    
  function initializeCustomerReviews() {
    document.querySelectorAll('[data-customer-reviews]').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const track = root.querySelector('.ag-customer-reviews__track');
      const previous = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const cards = Array.from(track.querySelectorAll('.ag-customer-review'));
      const count = root.querySelector('[data-review-count]');
      function update() {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        const visible = cards.filter(function (card) { return !card.hidden; });
        const bounds = track.getBoundingClientRect();
        const shown = visible.map(function (card, index) { return { rect: card.getBoundingClientRect(), index: index + 1 }; }).filter(function (item) { return item.rect.left < bounds.right - 24 && item.rect.right > bounds.left + 24; });
        count.textContent = shown.length ? shown[0].index + '-' + shown[shown.length - 1].index + ' / ' + visible.length : '0 / ' + visible.length;
      }
      function move(direction) {
        const card = cards.find(function (item) { return !item.hidden; });
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        const perPage = Math.max(1, Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).columnGap)) / step + 0.01));
        track.scrollBy({ left: direction * step * perPage, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initializeCustomerReviews();
  document.addEventListener('shopify:section:load', initializeCustomerReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-home-products"] && !Shopify.designMode) return;
  try {
    
  function initializeProductSliders() {
    document.querySelectorAll('.ag-live-products').forEach(function(root) {
      if (root.dataset.sliderReady) return;
      root.dataset.sliderReady = 'true';
      const track = root.querySelector('.ag-live-products__grid');
      const prev = root.querySelector('[data-product-prev]');
      const next = root.querySelector('[data-product-next]');
      if (!prev || !next) return;
      function update() {
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      function move(direction) {
        const card = track.querySelector('.ag-live-card');
        if (!card) return;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      prev.addEventListener('click', function(){ move(-1); });
      next.addEventListener('click', function(){ move(1); });
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initializeProductSliders();
  document.addEventListener('shopify:section:load', initializeProductSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-macro-calculator"]) return;
  try {
    
function agCalculateMacros(input) {
  const { age, sex, kg, cm, activity, goal } = input;
  if (![age, kg, cm, activity].every(Number.isFinite) || !Number.isInteger(age) || age < 18 || age > 80 || kg < 40 || kg > 250 || cm < 130 || cm > 230 || !['male','female'].includes(sex) || ![1.2,1.375,1.465,1.55,1.725,1.9].includes(activity) || !['cut','maintain','bulk'].includes(goal)) throw new Error('Please check your details. This tool supports ages 18-80, heights 130-230 cm and weights 40-250 kg (or their imperial equivalents).');
  if (kg / ((cm / 100) ** 2) < 18.5) throw new Error('This calculator cannot provide a suitable target for these measurements. A registered dietitian can help you find an appropriate plan.');
  const resting = 10 * kg + 6.25 * cm - 5 * age + (sex === 'male' ? 5 : -161);
  const maintenance = resting * activity;
  const target = Math.round(maintenance + (goal === 'cut' ? -500 : goal === 'bulk' ? 500 : 0));
  if (target < 1500 || target > 5000) throw new Error('Your estimate is outside this general calculator\'s range. Please speak to a registered dietitian for a personalised target.');
  return { calories: target, maintenance: Math.round(maintenance), protein: Math.round(target * .25 / 4.1), fat: Math.round(target * .25 / 8.8), carbs: Math.round(target * .5 / 3.75) };
}
function agInitMacro(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('form');
  const field = name => form.elements.namedItem(name);
  const get = selector => root.querySelector(selector);
  let units = 'metric';
  const clear = () => {
    get('[data-results]').hidden = true;
    get('.ag-macro__results').hidden = true;
    get('[data-error]').hidden = true;
  };
  form.addEventListener('input', clear);
  form.addEventListener('change', () => {
    clear();
    const next = field('units').value;
    if (next === units) return;
    const weight = Number(field('weight').value);
    if (field('weight').value && Number.isFinite(weight)) field('weight').value = (next === 'imperial' ? weight / .45359237 : weight * .45359237).toFixed(2);
    if (next === 'imperial' && field('cm').value) {
      let inches = Math.round(Number(field('cm').value) / 2.54 * 10) / 10;
      field('feet').value = Math.floor(inches / 12);
      field('inches').value = (inches % 12).toFixed(1);
    } else if (next === 'metric' && field('feet').value && field('inches').value !== '') {
      field('cm').value = ((Number(field('feet').value) * 12 + Number(field('inches').value)) * 2.54).toFixed(1);
    }
    units = next;
    const metric = units === 'metric';
    get('[data-metric-height]').hidden = !metric;
    field('cm').disabled = !metric;
    get('[data-imperial-height]').hidden = metric;
    get('[data-imperial-height]').disabled = metric;
    get('[data-weight-label]').textContent = metric ? 'Weight (kg)' : 'Weight (lb)';
    field('weight').min = metric ? '40' : '88.18';
    field('weight').max = metric ? '250' : '551.16';
    field('weight').placeholder = metric ? 'e.g. 75' : 'e.g. 165';
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    clear();
    if (!form.reportValidity()) return;
    try {
      const result = agCalculateMacros({ age: Number(field('age').value), sex: field('sex').value, kg: Number(field('weight').value) * (units === 'metric' ? 1 : .45359237), cm: units === 'metric' ? Number(field('cm').value) : (Number(field('feet').value) * 12 + Number(field('inches').value)) * 2.54, activity: Number(field('activity').value), goal: field('goal').value });
      for (const key of ['calories','protein','carbs','fat']) get('[data-' + key + ']').textContent = result[key].toLocaleString('en-GB');
      get('[data-maintenance]').textContent = 'Estimated maintenance: ' + result.maintenance.toLocaleString('en-GB') + ' kcal / day.';
      get('[data-goal-title]').textContent = {cut:'Your goal: lose weight',maintain:'Your goal: maintain weight',bulk:'Your goal: gain weight'}[field('goal').value];
      get('.ag-macro__results').hidden = false;
      get('[data-results]').hidden = false;
      get('.ag-macro__results').focus({preventScroll:true});
      get('.ag-macro__results').scrollIntoView({behavior:'auto',block:'start'});
    } catch (error) { get('[data-error]').textContent = error.message; get('[data-error]').hidden = false; }
  });
  get('[type=submit]').disabled = false;
}
function agPlaceMacroNotes(root) {
  const method = root.querySelector('.ag-macro__method') || document.querySelector('.ag-macro-foods__inner > .ag-macro__method');
  const disclaimer = root.querySelector('.ag-macro__disclaimer') || document.querySelector('.ag-macro-foods__inner > .ag-macro__disclaimer');
  if (!method || !disclaimer) return;
  let anchor = root.querySelector('[data-ag-macro-notes-anchor]');
  if (!anchor) {
    anchor = document.createElement('span');
    anchor.hidden = true;
    anchor.dataset.agMacroNotesAnchor = '';
    method.before(anchor);
  }
  const place = () => {
    const foodGuide = document.querySelector('.ag-macro-foods__inner');
    const quickTip = foodGuide?.querySelector('.ag-macro-foods__planning');
    const help = document.querySelector('.ag-macro-help');
    const helpSection = help?.closest('.shopify-section') || help;
    if (!foodGuide || !quickTip) return;
    if (helpSection) quickTip.after(helpSection);
    method.open = false;
    foodGuide.append(method, disclaimer);
  };
  place();
}
document.querySelectorAll('[data-ag-macro]').forEach(agInitMacro);
document.querySelectorAll('[data-ag-macro]').forEach(agPlaceMacroNotes);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ag-macro]').forEach(agInitMacro));
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ag-macro]').forEach(agPlaceMacroNotes));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-macro-help"]) return;
  try {
    
function agInitPlanChat(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const button = root.querySelector('[data-open-plan-chat]');
  const status = root.querySelector('[data-plan-chat-status]');
  button.addEventListener('click', async event => {
    event.preventDefault();
    event.stopPropagation();
    button.disabled = true;
    status.textContent = 'Opening chat...';
    try {
      let clickedLauncher;
      for (let attempt = 0; attempt < 60; attempt++) {
        const shell = document.querySelector('shopify-chat')?.shadowRoot;
        const runtime = shell?.querySelector('shopify-agent-runtime')?.shadowRoot;
        const launcher = runtime?.querySelector('button[part="activator"]') || shell?.querySelector('button[part="activator"]');
        if (launcher) {
          if (launcher.getAttribute('aria-expanded') === 'true') {
            status.textContent = '';
            return;
          }
          if (launcher !== clickedLauncher) {
            launcher.dispatchEvent(new MouseEvent('click', { bubbles: true, composed: true, cancelable: true, detail: 1, view: window }));
            clickedLauncher = launcher;
          }
        }
        await new Promise(resolve => setTimeout(resolve, 250));
      }
      status.textContent = 'Chat could not open. Please try the Need help? chat button or refresh the page and try again.';
    } finally { button.disabled = false; }
  });
}
document.querySelectorAll('[data-macro-help]').forEach(agInitPlanChat);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-macro-help]').forEach(agInitPlanChat));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('pointerover', function(event) {
  if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const menu = event.target.closest('.ag-shop-menu');
  if (menu && !menu.contains(event.relatedTarget)) menu.open = true;
});
document.addEventListener('pointerout', function(event) {
  if (event.pointerType !== 'mouse') return;
  const menu = event.target.closest('.ag-shop-menu');
  if (menu && !menu.contains(event.relatedTarget) && !menu.contains(document.activeElement)) menu.open = false;
});
document.addEventListener('focusout', function(event) {
  const menu = event.target.closest('.ag-shop-menu');
  if (menu && !menu.contains(event.relatedTarget) && !menu.matches(':hover')) menu.open = false;
});
document.addEventListener('click', function(event) {
  document.querySelectorAll('.ag-shop-menu[open]').forEach(function(menu) {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ag-shop-menu[open]').forEach(function(menu) {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();
})();
